import React from 'react';

const UserAvatarPlaceholder = ({ className = 'profileAvatar__placeholder', ...props }) => (
    <svg
        className={className}
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        {...props}
    >
        <circle cx="48" cy="36" r="20" fill="#6C7D91" />
        <ellipse cx="48" cy="82" rx="32" ry="20" fill="#6C7D91" />
    </svg>
);

export default UserAvatarPlaceholder;
